import breakpoint, { IBreakPoint } from './breakpoint';

export type { IBreakPoint };
export default breakpoint;
